export const addNewFile = (file, addNewFileCallback) => {
  parseInBase64(file).then((base64) => {
    addNewFileCallback({
      Name: file.name,
      ContentType: file.type,
      Content: base64,
      //size
    });
  });
};

const parseInBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};
